import {useMutation, gql} from '@apollo/client'

export const MUTATE_REMOVE_CONSTITUENTS_FROM_SAVED_LIST = gql`
  mutation MUTATE_REMOVE_CONSTITUENTS_FROM_SAVED_LIST(
    $listName: String!
    $constituentId: [String!]!
    $azureRole: String
  ) {
    removeFromList(listName: $listName, constituentId: $constituentId, azureRole: $azureRole) {
      removeFromList {
        listName
      }
    }
  }
`

export function useDeleteConstituentFromSavedList() {
  return useMutation(MUTATE_REMOVE_CONSTITUENTS_FROM_SAVED_LIST, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
